(ns frontend.view.components.timeline.entry.oppo-add-to-portfolio
  (:require [frontend.view.components.timeline.entry.declaration :as te]
            [frontend.view.components.timeline.entry.default-item :as default]
            [frontend.view.components.timeline.entry.utils :as utils]))

(defmethod te/timeline-entry-view :op.oppo/add-to-portfolio [{entry :entry}]
  [default/timeline-item-view entry utils/oppo-named-title-generator default/body-generator default/timestamp-generator])
